import * as React from 'react';

import {AnimatingBookmark} from 'shells/onboarding-checklist/animating-bookmark';
import {Sidebar} from 'shells/sidebar/sidebar';

import type {CueCard} from '../consts/cue-card-collection';
import {CueCardStack} from '../layout/cue-card-stack';

import styles from './glossary-sidebar.module.css';

type Props = {
    sidebarTitle?: string;
    cards: CueCard[];
    onClose: () => void;
};

export function GlossarySidebar(props: Props) {
    const sidebarHeaderRef = React.useRef(null);
    const [headerHeight, setHeaderHeight] = React.useState<number | null | undefined>(undefined);

    React.useLayoutEffect(() => {
        if (sidebarHeaderRef.current) {
            // @ts-expect-error
            setHeaderHeight(sidebarHeaderRef.current.clientHeight);
        }
    }, []);

    return (
        <Sidebar isOpen={true} onClose={props.onClose}>
            <div ref={sidebarHeaderRef}>
                <div className={styles['bookmark-container']}>
                    <AnimatingBookmark />
                </div>
                {props.sidebarTitle && <div className={styles.title}>{props.sidebarTitle}</div>}
            </div>
            <div style={{position: 'relative', height: '100%'}}>
                <div
                    // @ts-expect-error
                    style={{height: headerHeight && `calc(100% - ${headerHeight}px`}}
                    className={styles['cue-cards-container']}
                >
                    <CueCardStack
                        cards={props.cards}
                        afterOnClickCta={props.onClose}
                        noBookmark={true}
                    />
                </div>
            </div>
        </Sidebar>
    );
}
